const Inactive = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
            <circle cx="6" cy="6.5" r="6" fill="#B1993A"/>
        </svg>
    )
}

export default Inactive;